import React, { useEffect, useState, useRef } from 'react';
import './styles/MicrophoneModal.css';

const MicrophoneModal = ({ isOpen, onClose, isListening, transcriptionText }) => {
  const [visualizerValues, setVisualizerValues] = useState(Array(16).fill(5));
  const modalRef = useRef(null);

  // Animate visualizer bars when listening
  useEffect(() => {
    if (!isListening) {
      setVisualizerValues(Array(16).fill(5));
      return;
    }

    const interval = setInterval(() => {
      const newValues = Array(16).fill().map(() => 
        Math.floor(Math.random() * 35) + 5
      );
      setVisualizerValues(newValues);
    }, 100);

    return () => clearInterval(interval);
  }, [isListening]);

  // Handle click outside to close
  useEffect(() => {
    if (!isOpen) return;
    
    // Add active class after a small delay to trigger animation
    const timer = setTimeout(() => {
      if (modalRef.current) {
        modalRef.current.classList.add('active');
      }
    }, 10);

    return () => clearTimeout(timer);
  }, [isOpen]);

  // Handle closing animation
  const handleClose = () => {
    if (modalRef.current) {
      modalRef.current.classList.remove('active');
      // Wait for animation to complete before actually closing
      setTimeout(() => {
        onClose();
      }, 300);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="microphone-modal" ref={modalRef}>
      <div className="microphone-container">
        <div 
          className={`microphone-icon-container ${isListening ? 'listening' : ''}`}
          onClick={onClose}
        >
          <div className="pulse-ring"></div>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M12 2a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3Z"></path>
            <path d="M19 10v2a7 7 0 0 1-14 0v-2"></path>
            <line x1="12" y1="19" x2="12" y2="22"></line>
          </svg>
        </div>

        <h2 className="mic-status-text">
          {isListening ? "Listening..." : "Tap to speak"}
        </h2>
        
        <p className="mic-hint-text">
          {isListening 
            ? "Speak clearly. I'm listening to your request."
            : "Tap the microphone icon to start speaking"
          }
        </p>

        <div className={`visualizer-container ${isListening ? 'listening' : ''}`}>
          {visualizerValues.map((height, index) => (
            <div 
              key={index} 
              className="visualizer-bar"
              style={isListening ? {} : { height: `${height}px` }}
            ></div>
          ))}
        </div>

        {transcriptionText && (
          <div className="transcription-text">
            "{transcriptionText}"
          </div>
        )}

        <div className="mic-button-container">
          <button className="mic-close-button" onClick={handleClose}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default MicrophoneModal; 